export const FETCH_SEATING_CHARTS = 'line-up/event/FETCH_SEATING_CHARTS';
export const FETCH_ALL_SEATING_CHARTS =
  'line-up/event/FETCH_ALL_SEATING_CHARTS';
export const GET_SEATING_USER = 'line-up/event/GET_SEATING_USER';
export const DELETE_SEATING_CHART = 'line-up/event/DELETE_SEATING_CHART';
